import {Payload} from '../../../../../../core/service/payload/payload';
import {CustomDatePayload} from '../../../../../../common/custom-date/entity/payload/custom-date.payload';

export class MedicalRecordProblemCreateUpdatePayload implements Payload{

    partnerId: number;
    consultationId: number;
    typeValue: string;

    from: CustomDatePayload;
    to: CustomDatePayload;

    comment: string;
    involvedPartnerIds: number[] = [];

    locations: string[] = [];
    locationComment: string;

    whens: string[] = [];
    whenComment: string;
}
